/**
 * Marquee Component
 * Uses jQuery marquee plugin
 */
export class Marquee {
    constructor() {
        this.marquees = [];
    }

    init() {
        // Wait for jQuery and marquee plugin to be available
        if (
            typeof jQuery === "undefined" ||
            typeof jQuery.fn.marquee === "undefined"
        ) {
            // Retry after a short delay if jQuery is not ready
            setTimeout(() => this.init(), 100);
            return;
        }

        const $marquees = jQuery(".no-marquee");
        if (!$marquees.length) return;

        $marquees.each((index, element) => {
            this.initMarquee(jQuery(element));
        });
    }

    initMarquee($marquee) {
        const duration =
            parseFloat($marquee.attr("data-marquee-duration")) || 20;
        
        const pauseOnHover = $marquee.attr("data-pause-on-hover");
        const shouldPauseOnHover = pauseOnHover === undefined || pauseOnHover === "true";

        // Initialize jQuery marquee
        // duplicated: true와 duplicateCount: 2로 충분한 복제 보장
        $marquee.marquee({
            duration: duration * 1000, // Convert seconds to milliseconds
            gap: 0, // Gap is handled by CSS
            delayBeforeStart: 0,
            direction: "left",
            duplicated: true, // 자동 복제 활성화
            duplicateCount: 2, // 2번 복제하여 충분한 콘텐츠 확보
            startVisible: true, // Start with content visible
            pauseOnHover: shouldPauseOnHover, // Built-in hover pause functionality
            allowCss3Support: true,
            css3easing: "linear",
            easing: "linear",
        });

        // Store reference
        this.marquees.push($marquee);
    }
}
